export default __webpack_public_path__ + "images/yellow-80.png";